import { composeWithDevTools } from '@redux-devtools/extension'
import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createCompressor from 'redux-persist-transform-compress'
import { thunk } from 'redux-thunk'
import rootReducer from './rootReducer'

const compressor = createCompressor()
const persistConfig = {
  key: 'root',
  storage,
  transforms: [compressor],
}
const persistedReducer = persistReducer(persistConfig, rootReducer)
const middleware = [thunk]

export const store = createStore(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middleware)),
)

export const persistor = persistStore(store)
